import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import Email from '@transferz/fe-component-library/src/components/icons/EmailIcon';
import Phone from '@transferz/fe-component-library/src/components/icons/PhoneIcon';
import User from '@transferz/fe-component-library/src/components/icons/UserIcon';
import Input from '@transferz/fe-component-library/src/components/input/Input';
import { useLocalize } from 'localize-react';
import React, { ChangeEvent, useContext } from 'react';

import { isValidEmail } from '../../../../utils/utils';
import { FormContext } from '../../FormContext';

export const PassengerDetailsEdit: React.FC<any> = ({ travellerInfo }) => {
  const { translate } = useLocalize();
  const { formData, setFormData, formErrors, setFormErrors } = useContext(FormContext);

  const onChange = (key: string, value: string) => {
    setFormData({
      ...formData,
      travellerInfo: {
        ...formData.travellerInfo,
        [key]: value,
      },
    });
  };

  const setErrors = (key: string, value: boolean) => {
    setFormErrors({
      ...formErrors,
      [key]: value,
    });
  };

  return (
    <div className="card-wrap">
      <Card title={translate('passengerDetailsTitle')} collapsed={false} collapsibleIcon={false}>
        <div className="form-input">
          <Input
            name="firstName"
            type="text"
            className="form-item mr-16"
            label={translate('booking_firstName')}
            iconLeft={<User />}
            value={formData?.travellerInfo?.firstName || ''}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              onChange('firstName', event.target.value);
              setErrors('firstName', !event.target.value);
            }}
            confirmed={formErrors?.firstName !== undefined}
            error={formErrors?.firstName
              ? translate(formData?.travellerInfo?.firstName.trim() === '' ? 'requiredField' : '')
              : ''}
          />
          <Input
            name="lastName"
            type="text"
            className="form-item"
            label={translate('booking_lastName')}
            iconLeft={<User />}
            value={formData?.travellerInfo?.lastName || ''}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              onChange('lastName', event.target.value);
              setErrors('lastName', !event.target.value);
            }}
            confirmed={formErrors?.lastName !== undefined}
            error={formErrors?.lastName
              ? translate(formData?.travellerInfo?.lastName.trim() === '' ? 'requiredField' : '')
              : ''}
          />
        </div>
        { travellerInfo?.displayEmailAllowed && (
          <div className="form-input">
            <Input
              name="email"
              type="text"
              className="form-item"
              label={translate('booking_email')}
              iconLeft={<Email />}
              value={formData?.travellerInfo?.email || ''}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                onChange('email', event.target.value);
                setErrors('email', !isValidEmail(event.target.value));
              }}
              confirmed={formErrors?.email !== undefined}
              error={formErrors?.email
                ? translate(formData?.travellerInfo?.email.trim() === '' ? 'requiredField' : 'booking_invalidEmail')
                : ''}
            />
          </div>
        )}
        {travellerInfo?.phone && (
          <div className="form-input mb-12">
            <Input
              name="phone"
              type="text"
              className="form-item"
              label={translate('booking_phone')}
              iconLeft={<Phone />}
              value={formData?.travellerInfo?.phone || ''}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                const phoneNumberPattern = /^\+[1-9]\d{1,14}$/i;
                onChange('phone', event.target.value);
                setErrors('phone', !phoneNumberPattern.test(event.target.value));
              }}
              confirmed={formErrors?.phone !== undefined}
              error={formErrors?.phone
                ? translate(formData?.travellerInfo?.phone.trim() === '' ? 'requiredField' : 'booking_invalidPhoneNumber')
                : ''}
            />
          </div>
        )}
      </Card>
    </div>
  );
};
